"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("../../elements/Typography"));

var _Drawer2 = _interopRequireDefault(require("./Drawer.css"));

var _ThreeDots = _interopRequireDefault(require("./icons/ThreeDots"));

var _CloseX = _interopRequireDefault(require("./icons/CloseX"));

var _Message = _interopRequireDefault(require("./icons/Message"));

var DRAWER_HEADER_TYPE = {
  DARK: 'dark',
  LIGHT: 'light'
};

var Drawer =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Drawer, _React$PureComponent);

  function Drawer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Drawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderIcon", function (action, IconNode) {
      var classes = _this.props.classes;
      return React.createElement(_IconButton.default, {
        key: action.icon,
        className: classes.actionIcon,
        onClick: action.onClick
      }, React.createElement(IconNode, null));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAction", function (action) {
      switch (action.icon) {
        case 'close':
          return _this.renderIcon(action, _CloseX.default);

        case 'threeDots':
          return _this.renderIcon(action, _ThreeDots.default);

        case 'message':
          return _this.renderIcon(action, _Message.default);

        default:
          return null;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Drawer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchor = _this$props.anchor,
          classes = _this$props.classes,
          content = _this$props.content,
          open = _this$props.open;
      return React.createElement(_Drawer.default, {
        anchor: anchor,
        open: open,
        ModalProps: {
          hideBackdrop: true
        }
      }, this.header, React.createElement("div", {
        className: classes.content
      }, React.createElement(_Typography.default, {
        fullHeight: true
      }, content)), this.footer);
    }
  }, {
    key: "header",
    get: function get() {
      var _this$props2 = this.props,
          actions = _this$props2.actions,
          classes = _this$props2.classes,
          headerType = _this$props2.headerType,
          onClose = _this$props2.onClose,
          title = _this$props2.title;
      var fullActions = onClose ? [].concat((0, _toConsumableArray2.default)(actions), [{
        icon: 'close',
        onClick: onClose
      }]) : actions;
      return React.createElement("div", {
        className: (0, _clsx.default)(classes.header, headerType === DRAWER_HEADER_TYPE.DARK ? classes.darkHeader : classes.lightHeader)
      }, React.createElement(_Typography.default, {
        className: classes.title,
        variant: "drawerTitle"
      }, title), React.createElement("div", {
        className: classes.actions
      }, fullActions.map(this.renderAction)));
    }
  }, {
    key: "footer",
    get: function get() {
      var _this$props3 = this.props,
          classes = _this$props3.classes,
          footer = _this$props3.footer;

      if (!footer) {
        return null;
      }

      return React.createElement(React.Fragment, null, React.createElement(_Divider.default, null), React.createElement("div", {
        className: classes.footer
      }, footer));
    }
  }]);
  return Drawer;
}(React.PureComponent);

Drawer.defaultProps = {
  actions: [],
  anchor: 'right',
  footer: null,
  headerType: DRAWER_HEADER_TYPE.LIGHT
};
Drawer.propTypes = {
  /**
   * The actions of the drawer.
   * A list of allowed icon strings, in order of appearance.
   * There must also be four or fewer icons.
   */
  actions: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Icon of the item
     */
    icon: PropTypes.oneOf(['message', 'threeDots']).isRequired,

    /**
     * Callback on clicking a certain icon
     */
    onClick: PropTypes.func.isRequired
  })),

  /**
   * The position of the drawer.
   */
  anchor: PropTypes.oneOf(['right', 'left']),

  /**
   * The content of the drawer.
   */
  content: PropTypes.node.isRequired,

  /**
   * The footer of the drawer.
   */
  footer: PropTypes.node,

  /**
   * Definies header color type of the drawer.
   */
  headerType: PropTypes.oneOf([DRAWER_HEADER_TYPE.DARK, DRAWER_HEADER_TYPE.LIGHT]),

  /**
   * Function fires on close icon click).
   */
  onClose: PropTypes.func,

  /**
   * If true, the drawer is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Header title of the drawer
   */
  title: PropTypes.string.isRequired
};

var _default = (0, _styles.withStyles)(_Drawer2.default)(Drawer);

exports.default = _default;